import { Context } from '@nuxt/types';
import { rootContainer } from '~/container';
import { PuLangFetch, PuLangFetchInstance } from '~/lang/utils/pulangfetch';
import PuFetch, { PuFetchAbstract } from '~/utility/http';
import { SYMBOLS } from './symbols';
var plugin = (_ref, inject) => {
  var {
    $axios,
    app
  } = _ref;
  if ($axios && !rootContainer.isBound(SYMBOLS.NuxtAxiosInstance)) {
    $axios.defaults.timeout = 120000;
    rootContainer.bind(SYMBOLS.NuxtAxiosInstance).toConstantValue($axios);
  }
  if (app.i18n && !rootContainer.isBound('i18n')) {
    rootContainer.bind('i18n').toConstantValue(app.i18n);
  }
  if (!rootContainer.isBound(PuFetchAbstract)) {
    rootContainer.bind(PuFetchAbstract).to(PuFetch);
  }
  if (!rootContainer.isBound(SYMBOLS.PuFetchInstance)) {
    rootContainer.bind(SYMBOLS.PuFetchInstance).to(PuFetch);
  }
  if (!rootContainer.isBound(PuLangFetch)) {
    rootContainer.bind(PuLangFetch).to(PuLangFetchInstance);
  }
  inject('puLangFetch', rootContainer.get(PuLangFetch));
  if (app.$sentry && !rootContainer.isBound(SYMBOLS.SentryInstance)) {
    rootContainer.bind(SYMBOLS.SentryInstance).toConstantValue(app.$sentry);
  }
  if (app.$sentryReady && !rootContainer.isBound(SYMBOLS.SentryReadyInstance)) {
    rootContainer.bind(SYMBOLS.SentryReadyInstance).toConstantValue(app.$sentryReady);
  }
};
export default plugin;